import CleanCash from './CleanCash.jsx';

export default CleanCash;